import axios from 'axios'
import qs from 'qs'
import JSEncrypt from 'jsencrypt';
import SparkMD5 from "spark-md5";
let Base64 = require("js-base64").Base64;
var encryptStr = new JSEncrypt();
axios.defaults.timeout = 500000; //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.baseURL = '';
axios.defaults.withCredentials = true

// 请求拦截器
axios.interceptors.request.use((config) => {
    var pubKey = window.sessionStorage.getItem("trip");
    if (pubKey) {
        let cnsign =
            Math.floor(10000000 + Math.random() * 90000000) +
            "zwjt8081!@#DF*F&^SKD" +
            new Date().getTime();
       
        encryptStr.setPublicKey(pubKey); // 设置 加密公钥
        config.headers["cn-sign"] = encryptStr.encrypt(cnsign);
    }

    return config;
});

const HTTP = {};
let ip = sessionStorage.getItem('webIp')
let timestamp = new Date().getTime()
let nonce = ip + '-' + timestamp
let sign = sessionStorage.getItem('token') + nonce
let spark = new SparkMD5()
spark.append(sign);
let signMd5 = spark.end();

HTTP.setToken = function (token) {
    axios.defaults.headers.post['token'] = token;
    axios.defaults.headers.get['token'] = token;
}
var pubKey = window.sessionStorage.getItem('trip')
let cnsign =  Math.floor(10000000 + Math.random() * 90000000) + "zwjt8081!@#DF*F&^SKD" + new Date().getTime()

encryptStr.setPublicKey(pubKey); // 设置 加密公钥
if (pubKey) {
    axios.defaults.headers['cn-sign'] = encryptStr.encrypt(cnsign);
}

HTTP.json = function (url, params, parseResult = true) {
    if (params) {
        let param = JSON.stringify(params)
        var pubKey = window.sessionStorage.getItem('trip')
        encryptStr.setPublicKey(pubKey); // 设置 加密公钥
        var datas = encryptStr.encrypt(param);  // 进行加密
    }
    else {
        var datas = params
    }
    return new Promise((resolve, reject) => {
        axios.post(url, datas, {
            headers: {
                "content-Type": "application/json",
                "zw-nonce" : nonce,
                "zw-sign" : signMd5,
                "cn-sign" : encryptStr.encrypt(cnsign)
            }
        })
            .then(
                response => {
                    let result = response.data
                    if (parseResult) {
                        if (response.status === 200) {
                            resolve(result.content)
                        } else {
                            reject(result);
                        }
                    } else {
                        resolve(result)
                    }
                },
                err => {
                    reject(err)
                }
            )
            .catch(error => {
                reject(error)
            })
    })
}
HTTP.get = function (url, params, parseResult = true) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            headers: {
                "content-Type": "application/json",
                "zw-nonce" : nonce,
                "zw-sign" : signMd5,
                "cn-sign" : encryptStr.encrypt(cnsign)
            }
            , params
        }).then(response => {
            let result = response.data
            if (parseResult) {
                if (response.status === 200) {
                    resolve(result.content)
                } else {
                    reject(result.content)
                }
            } else {
                resolve(result)
            }
        },
            err => {
                reject(err)
            }
        )
            .catch(error => {
                reject(error)
            })
    })
}
HTTP.post = function (url, params, parseResult = true) {
    if (params) {
        let base = ''

        for (let key in params) {
            base += key + '=' + params[key] + '&'
        }
        base = base.substr(0, base.length - 1);
        var pubKey = window.sessionStorage.getItem('trip')
        
        encryptStr.setPublicKey(pubKey); // 设置 加密公钥
        var datas = encryptStr.encrypt(base);  // 进行加密
    }
    else {
        var datas = params
    }

    //        params = Base64.encode(datas);
    return new Promise((resolve, reject) => {
        axios.post(url, datas, {
            headers: {
                "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
                "zw-nonce" : nonce,
                "zw-sign" : signMd5,
                "cn-sign" : encryptStr.encrypt(cnsign)
            }
        })
            .then(
                response => {
                    let result = response.data
                    if (parseResult) {
                        if (response.status === 200) {
                            resolve(result.content)
                        } else {
                            reject(result);
                        }
                    } else {
                        resolve(result)
                    }
                },
                err => {
                    reject(err)
                }
            )
            .catch(error => {
                reject(error)
            })
    })
}

HTTP.postFormData = function (url, params, parseResult = true) {
    return new Promise((resolve, reject) => {
        axios.post(url, params, {
            headers: {
                'Content-Type': 'application/json',
                'rsa': 'no',
                'token': sessionStorage.getItem('token'),
                "zw-nonce" : nonce,
                "zw-sign" : signMd5,
                "cn-sign" : encryptStr.encrypt(cnsign)
            }
        })
            .then(response => {
                let result = response.data;

                if (parseResult) {
                    if (result.code === 0) {
                        resolve(result.message);
                    } else {
                        reject(result)
                    }
                } else {
                    resolve(result);
                }
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
HTTP.put = function (url, params, parseResult = true) {
    if (params) {
        let base = "";

        for (let key in params) {
            base += key + "=" + params[key] + "&";
        }
        base = base.substr(0, base.length - 1);

        var pubKey = window.sessionStorage.getItem("trip");
        
        encryptStr.setPublicKey(pubKey); // 设置 加密公钥
        var datas = encryptStr.encrypt(base); // 进行加密
    } else {
        var datas = params;
    }
    return new Promise((resolve, reject) => {
        axios
            .put(url, datas, {
                headers: {
                    "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
                    "zw-nonce" : nonce,
                    "zw-sign" : signMd5,
                    "cn-sign" : encryptStr.encrypt(cnsign)
                },
            })
            .then(
                (response) => {
                    let result = response.data;
                    if (parseResult) {
                        if (response.status === 200) {
                            resolve(result.content);
                        } else {
                            reject(result);
                        }
                    } else {
                        resolve(result);
                    }
                },
                (err) => {
                    reject(err);
                }
            )
            .catch((error) => {
                reject(error);
            });
    });
};
HTTP.delete = function (url, params, parseResult = true) {
    return new Promise((resolve, reject) => {
        axios
            .delete(url + "?" + qs.stringify(params), {
                headers: {},
            })
            .then(
                (response) => {
                    let result = response.data;
                    if (parseResult) {
                        if (response.status === 200) {
                            resolve(result.content);
                        } else {
                            reject(result);
                        }
                    } else {
                        resolve(result);
                    }
                },
                (err) => {
                    reject(err);
                }
            )
            .catch((error) => {
                reject(error);
            });
    });
};

export default HTTP



// WEBPACK FOOTER //
// ./src/core/api/config/api.js